import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'minimumCountOne',
    standalone: false
})
export class MinimumCountOnePipe implements PipeTransform {

  transform(value: number): number {
    return value === 0 ? 1 : value;
  }

}
